import { Component, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { ParentNavigationItem } from '@next/core-lib/navigation';

import { Environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent {
  private readonly env = inject<Environment>(EnvironmentInjector);

  navigationItems: ParentNavigationItem[] = [
    {
      relativeUrl: '/',
      label: 'adviceOverview',
      icon: 'dashboard',
    },
    {
      absoluteUrl: this.env.PROPRIETARY_FERTILIZER_URL,
      label: 'proprietary-fertilizerTitle',
      icon: 'dashboard',
    },
  ];
}
